<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 class="text-xs-center">
      <h1>Vérifiez votre email</h1>
      <div>
        <img :src="emailIconUrl" alt="Vérifiez votre adresse email">
      </div>
      <p class="text-xs-justify">
        Merci de rejoindre Weview. Un email de confirmation vient de vous être envoyé, cliquez sur le lien dans cet email pour continuer le processus d'inscription.
      </p>
      <p class="text-xs-justify">
        Note : Cet email peut prendre quelques minutes à arriver dans votre boite de réception. En cas de non réception, merci de nous écrire sur <a href="mailto:inscriptions@weview.fr">inscriptions@weview.fr</a>.
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import rootUrl from '@/../config/root-url';

export default {
  name : `registrationSuccess`,
  computed : {
    emailIconUrl () {
      return `${rootUrl}/static/img/new_email.gif`;
    },
  },
  mounted () {
    this.$store.dispatch(`isLoading`, false);
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 3rem;
}
p {
  font-size: 1.4rem;
}
h1, p {
  color: #444;
}
img {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 190px;
}
a {
  color: #3c6a92;
}
</style>



// WEBPACK FOOTER //
// RegistrationSuccess.vue?3cede604